<article>
    <div>
        <img src="assets/images/img-login.png">
        <div class="box">
            <div>
                <h2>관리자 코드번호를 입력해주세요.</h2><br>
            </div>
            <div class="inputbox">
                <input type="text" placeholder="Admin Code">
                <button>OK</button>
            </div>
        </div>
    </div>
</article>
